import requester from '@/lib/axios';
import { ActivityBlockType } from '@/models/Activity';
import ActivityProgress, {
  ActivityCorrectionStatusEnum,
  ActivityProgressShortView,
} from '@/models/ActivityProgress';
import { OrderingFrom } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';

export const ACTIVITY_PROGRESS_ORDERING_FIELDS = ['created_at'] as const;

export type ActivityProgressOrdering = OrderingFrom<
  typeof ACTIVITY_PROGRESS_ORDERING_FIELDS
>;

export interface ActivityProgressFilterParams {
  pageNumber?: number;
  pageSize?: number;
  activityId?: number[];
  userId?: number[];
  isActive?: boolean;
  courseProgressId?: number;
  search?: string;
  activityType?: ActivityBlockType[];
  klassId?: number[];
  unitId?: number[];
  teacherId?: number[];
  lessonId?: number[];
  correctionStatus?: ActivityCorrectionStatusEnum[];
  sentAtAfter?: string;
  sentAtBefore?: string;
  ordering?: ActivityProgressOrdering;
}
export async function listActivityProgress(
  params: ActivityProgressFilterParams = {},
) {
  const { data } = await requester().get<JsonApiResponse<ActivityProgress>>(
    'activity-progress/',
    {
      params,
    },
  );

  return data;
}

export async function listActivityProgressShortView(
  params: ActivityProgressFilterParams = {},
) {
  const { data } = await requester().get<
    JsonApiResponse<ActivityProgressShortView>
  >('activity-progress/short-view/', {
    params,
  });

  return data;
}

export const getActivityProgress = async (activityProgressId: number) => {
  const { data } = await requester().get<ActivityProgress>(
    `activity-progress/${activityProgressId}/`,
  );

  return data;
};

export const updateActivityProgress = async (
  activityProgressId: number,
  activityProgress: Partial<ActivityProgress>,
) => {
  const { data } = await requester().patch<ActivityProgress>(
    `activity-progress/${activityProgressId}/`,
    activityProgress,
  );
  return data;
};
